import { render, staticRenderFns } from "./FlowchartNodeView.vue?vue&type=template&id=abbf4a34&scoped=true"
import script from "./FlowchartNodeView.vue?vue&type=script&lang=js"
export * from "./FlowchartNodeView.vue?vue&type=script&lang=js"
import style0 from "./FlowchartNodeView.vue?vue&type=style&index=0&id=abbf4a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbf4a34",
  null
  
)

export default component.exports